import { render, staticRenderFns } from "./PreventionTotalList.vue?vue&type=template&id=3c27f001&scoped=true"
import script from "./PreventionTotalList.vue?vue&type=script&lang=js"
export * from "./PreventionTotalList.vue?vue&type=script&lang=js"
import style0 from "./PreventionTotalList.vue?vue&type=style&index=0&id=3c27f001&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c27f001",
  null
  
)

export default component.exports